import { configureStore } from "@reduxjs/toolkit";
import { REDUX_CONSTANTS } from "./action-constants";
import { authReducer } from "./auth/auth-slice";
import { commonReducer } from "./common/common-slice";

export const store = configureStore({
  reducer: {
    [REDUX_CONSTANTS.AUTH.FEATURE_KEY]: authReducer,
    [REDUX_CONSTANTS.COMMON.FEATURE_KEY]: commonReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: true,
});
